// extracted by mini-css-extract-plugin
export default {"image":"style_image__zQW2B","primaryImg":"style_primaryImg__EYtPg","options":"style_options__bQl9U","editorChoice":"style_editorChoice__aMHjy"};